//#region types
import { IconDefinitionConstants } from "utils/constants";
import { DialogEnums } from "models/enums";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import AgreementCreateFormContainer from "../../agreement/forms/createFormContainer";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function useCreateAgreementDialog() {
  const getAgreementDialog = (
    agreementId?: number,
    onSubmitSuccess?: () => void,
    nonEditable?: boolean
  ): DialogProps => {
    return {
      isOpen: false,
      title:
        agreementId !== undefined
          ? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Edit)
          : LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Agreement.AddAgreement),
      titleIcon: IconDefinitionConstants.WDocument,
      actions: !nonEditable
        ? [
            {
              text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Save),
              successMessage: TranslationKeys.Agreement.SubmitSuccessMessage,
            },
          ]
        : [],
      dialogType: DialogEnums.DialogType.Content,
      children: <AgreementCreateFormContainer agreementId={agreementId} nonEditable={nonEditable} />,
      maxWidth: "sm",
      onSubmit: onSubmitSuccess,
    };
  };

  return getAgreementDialog;
}

export default useCreateAgreementDialog;
